module.exports = (parcelRequire.load("aoCaG")).then(() => parcelRequire('hI4Sr'));